import { render, staticRenderFns } from "./secondarychecktable.vue?vue&type=template&id=20900b2c&scoped=true&"
import script from "./secondarychecktable.vue?vue&type=script&lang=js&"
export * from "./secondarychecktable.vue?vue&type=script&lang=js&"
import style0 from "./secondarychecktable.vue?vue&type=style&index=0&id=20900b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20900b2c",
  null
  
)

export default component.exports